module.exports = __webpack_public_path__ + "img/h-1.b435f746.png";